var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reports-icon",
    transform: "translate(8.4 8.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1274",
    "data-name": "Rectangle 1274",
    width: 56,
    height: 56,
    rx: 8,
    transform: "translate(-8.4 -8.4)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "records",
    transform: "translate(4.6 4.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4355",
    "data-name": "Path 4355",
    d: "M7.94,29.893a36.64,36.64,0,0,0,7.384.754,36.653,36.653,0,0,0,7.384-.754,9.219,9.219,0,0,0,7.186-7.186,36.555,36.555,0,0,0,0-14.768.876.876,0,0,0-.239-.443l-6.5-6.5a.87.87,0,0,0-.443-.239A36.539,36.539,0,0,0,7.94.754,9.217,9.217,0,0,0,.754,7.94a36.524,36.524,0,0,0,0,14.768A9.217,9.217,0,0,0,7.94,29.893M27.817,8.136H25.033A2.526,2.526,0,0,1,22.51,5.613V2.83ZM2.469,8.292A7.468,7.468,0,0,1,8.292,2.469a34.682,34.682,0,0,1,12.467-.287V5.613a4.279,4.279,0,0,0,4.275,4.275h3.431a34.8,34.8,0,0,1-.286,12.468,7.471,7.471,0,0,1-5.822,5.822,34.847,34.847,0,0,1-14.064,0,7.469,7.469,0,0,1-5.822-5.822,34.8,34.8,0,0,1,0-14.064",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4335",
    "data-name": "Path 4335",
    d: "M9.533,25.691H23.458a.876.876,0,0,0,0-1.752H9.533a.876.876,0,1,0,0,1.752",
    transform: "translate(-1.172 -3.241)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4336",
    "data-name": "Path 4336",
    d: "M9.533,18.462H23.458a.876.876,0,0,0,0-1.752H9.533a.876.876,0,1,0,0,1.752",
    transform: "translate(-1.172 -2.262)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4337",
    "data-name": "Path 4337",
    d: "M9.533,11.233h4.886a.876.876,0,1,0,0-1.752H9.533a.876.876,0,1,0,0,1.752",
    transform: "translate(-1.172 -1.284)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.25
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.f5bebc89c0d7f41ca01cecafdd62208c.svg";
export { ForwardRef as ReactComponent };